import { WORKSPACE_ADMIN_ROLES } from "@common/constants";
import { UserWorkspaceRole } from "@common/userWorkspaceRoles";
import { FinancialAccount } from "@common/types/financialAccount";
import { useUser } from "@hooks/useUser";
import { useActiveWorkspaceRole } from "./useActiveWorkspaceRole";

const REMOVE_ACCOUNT_ROLES = [
    ...WORKSPACE_ADMIN_ROLES,
    UserWorkspaceRole.ACCOUNTANT,
];

export function useCanRemoveFinancialAccount(account: FinancialAccount) {
    const role = useActiveWorkspaceRole();
    const user = useUser();

    const accountBelongsToUser = account.integrationAccounts?.some(
        (integrationAccount) =>
            integrationAccount.connection?.user?.id === user.id ||
            integrationAccount.integrationConnection?.createdByUserId ===
                user.id,
    );

    return (
        (role !== null && REMOVE_ACCOUNT_ROLES.includes(role)) ||
        !!accountBelongsToUser
    );
}
